export default "__VITE_ASSET__00IAUgB___"